import { useState } from "react";
import Input from "../ui/InputForm";
import Checkbox from "../ui/Checkbox";
import Button from "../ui/Button";
import "./AuthForm.css";

function LoginForm({ onSubmit }) {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    remember: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <h2>Welkom terug</h2>
      <p>Welkom terug, login met jouw gegevens.</p>

      <Input
        label="Gebruikersnaam"
        type="text"
        name="username"
        placeholder="Gebruikersnaam"
        value={formData.username}
        onChange={handleChange}
        required
      />

      <Input
        label="Wachtwoord"
        type="password"
        name="password"
        placeholder="Password"
        value={formData.password}
        onChange={handleChange}
        required
      />

      <div className="form-remember">
        <Checkbox
          name="remember"
          checked={formData.remember}
          onChange={handleChange}
          label="Onthoud voor 30 dagen"
        />
        <a href="/reset-password" className="forgot-link">Wachtwoord vergeten</a>
      </div>

      <Button type="submit" variant="primary" fullWidth>
        Login
      </Button>
    </form>
  );
}

export default LoginForm;